import { useCallback, useEffect, useState } from 'react'
import { DropPictureError, DropPictureProps } from '@komune-io/g2-components'
import { fileToBase64 } from '@komune-io/g2-utils'

export interface DropNamedPictureProps extends DropPictureProps {
  fileName: string | undefined
}
export const useDropZonePicture = (imgUrl?: string): DropNamedPictureProps => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)
  const [image, setImage] = useState<string | undefined>(imgUrl)
  const [fileName, setFileName] = useState<string | undefined>(imgUrl?.split("/").reverse()[0])

  useEffect(() => {
    setImage(imgUrl)
    setFileName(imgUrl?.split("/").reverse()[0])
  }, [imgUrl])

  const onDropError = useCallback((errorType: DropPictureError) => {
    if (errorType === 'file-too-large') {
      setErrorMessage("La taille de l'image est limité à 1Mo")
    } else if (errorType === 'file-invalid-type') {
      setErrorMessage("L'image doit être au format jpeg ou png")
    } else if (errorType === 'too-many-files') {
      setErrorMessage("Ne déposez qu'une seule image à la fois")
    } else {
      setErrorMessage("L'image est invalide")
    }
  }, [])

  const onPictureDropped = useCallback((image: File) => {
    setFileName(image.name)
    fileToBase64(image).then((base64) => {
      setImage(base64)
    })
  }, [setFileName, setImage])

  const onRemovePicture = useCallback(() => {
    setFileName(undefined)
    setImage(undefined)
  }, [setFileName, setImage])

  return {
    customErrorMessage: errorMessage,
    pictureUrl: image,
    fileName: fileName,
    onError: onDropError,
    onPictureDropped: onPictureDropped,
    onRemovePicture: onRemovePicture,
  }
}
